import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import dashboardService from 'services/dashboardService';

const initialState = {
    totalIp:null,
    totalDomain:null,
    openedResolvedIssues:null,
    assetsWithMostIssues:null,
    technologiesWithMostIssues:null,
    performanceTestResults: null,
    topIssues:null,
    dashboardDomains:null,
    sslExpire : [],
    countryInfo:[],
    domainIps:[],
    countryLoading:false,
    mapLoading:false,
    mapDomains: null,
    technology: [],
    subDomain: null,
    issue : null,
    categorisedVulnerability: null,
    errorMessage: '',
    totalIpLoading: false,
    totalDomainLoading: false,
    sslExpireLoading: false,
    subDomainLoading: false,
    categorisedVulnerabilityLoading: false,
    openedResolvedIssuesLoading: false,
    topIssuesLoading: false,
    getDashboardDomainsFilteredLoading: false,
    assetWithMostIssuesLoading: false,
    technologiesWithMostIssuesLoading: false,
    performanceTestResultLoading: false,
    domainIpsLoading: false
};

export const getTotalIp = createAsyncThunk(
    'dashboard/getTotalIp',
    async () => {
        try {
            return await dashboardService.getTotalIp();
        } catch (error) {
            console.log(error)
        }
    }
);

export const getTotalDomain = createAsyncThunk(
    'dashboard/getTotalDomain',
    async () => {
        try {
            return await dashboardService.getTotalDomain();
        } catch (error) {
            console.log(error)
        }
    }
);

export const getDomainIps = createAsyncThunk(
    'dashboard/getDomainIps',
    async () => {
        try {
            return await dashboardService.getDomainIps();
        } catch (error) {
            console.log(error)
        }
    }
);

export const getSslExpire = createAsyncThunk(
    'dashboard/getSslExpire',
    async () => {
        try {
            return await dashboardService.getSslExpire();
        } catch (error) {
            console.log(error)
        }
    }
);

export const getSubDomain = createAsyncThunk(
    'dashboard/getSubDomain',
    async () => {
        try {
            return await dashboardService.getSubDomain();
        } catch (error) {
            console.log(error)
        }
    }
);

export const getCategorisedVulnerability = createAsyncThunk(
    'dashboard/getCategorisedVulnerability',
    async () => {
        try {
            return await dashboardService.getCategorisedVulnerability();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getOpenedResolvedIssues = createAsyncThunk(
    'dashboard/getOpenedResolvedIssues',
    async () => {
        try {
            return await dashboardService.getOpenedResolvedIssues();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getTopIssues = createAsyncThunk(
    'dashboard/getTopIssues',
    async () => {
        try {
            return await dashboardService.getTopIssues();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getMapDomains = createAsyncThunk(
    'dashboard/getMapDomains', async ( data, {
        rejectWithValue
    }) => {
        try {
            return await dashboardService.getMapDomains(data);
        } catch (error) {
        return rejectWithValue(error);
        }
});

export const getAssetsWithMostIssues = createAsyncThunk(
    'dashboard/getAssetsWithMostIssues',
    async () => {
        try {
            return await dashboardService.getAssetsWithMostIssues();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getPerformanceTestResults = createAsyncThunk(
    'dashboard/getPerformanceTestResults',
    async () => {
        try {
            return await dashboardService.getPerformanceTestResults();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getTechnologiesWithMostIssues = createAsyncThunk(
    'dashboard/getTechnologiesWithMostIssues',
    async () => {
        try {
            return await dashboardService.getTechnologiesWithMostIssues();
        } catch (error) {
            console.log(error)
        }
    }
)

export const getDashboardDomainsFiltered = createAsyncThunk("domain/getDashboardDomainsFiltered", async (data, {
    rejectWithValue
}) => {
    try {
        const response = await dashboardService.getDashboardDomainsFiltered(data?.params, data?.data);
        return response;
    } catch (error) {
        return rejectWithValue(error);
    }
});

export const getCountryInfo = createAsyncThunk(
    'dashboard/getCountryInfo',
    async () => {
        try {
            return await dashboardService.getCountryInfo();
        } catch (error) {
            console.log(error)
        }
    }
);

export const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(getTotalIp.pending, (state, action) => {
            state.totalIpLoading = true;
        });
        builder.addCase(getTotalIp.fulfilled, (state, action) => {
            state.totalIp = action.payload.data;
            state.totalIpLoading = false;
        });
        builder.addCase(getTotalIp.rejected, (state, action) => {
            state.totalIpLoading = false;
        });
        builder.addCase(getTotalDomain.pending, (state, action) => {
            state.totalDomainLoading = true;
        });
        builder.addCase(getTotalDomain.fulfilled, (state, action) => {
            state.totalDomain = action.payload.data;
            state.totalDomainLoading = false;
        });
        builder.addCase(getTotalDomain.rejected, (state, action) => {
            state.totalDomainLoading = false;
        });
        builder.addCase(getDomainIps.pending, (state, action) => {
            state.domainIpsLoading = true;
        });
        builder.addCase(getDomainIps.fulfilled, (state, action) => {
            state.domainIps = action.payload.data;
            state.domainIpsLoading = false;
        });
        builder.addCase(getDomainIps.rejected, (state, action) => {
            state.domainIpsLoading = false;
        });
        builder.addCase(getSslExpire.pending, (state, action) => {
            state.sslExpireLoading = null;
        });
        builder.addCase(getSslExpire.fulfilled, (state, action) => {
            state.sslExpire = action.payload.data;
            state.sslExpireLoading = false;
        });
        builder.addCase(getSslExpire.rejected, (state, action) => {
            state.sslExpireLoading = false;
        });
        builder.addCase(getSubDomain.pending, (state, action) => {
            state.subDomainLoading = true;
        });
        builder.addCase(getSubDomain.fulfilled, (state, action) => {
            state.subDomain = action.payload.data;
            state.subDomainLoading = false;
        });
        builder.addCase(getSubDomain.rejected, (state, action) => {
            state.subDomainLoading = false;
        });
        builder.addCase(getCategorisedVulnerability.pending, (state, action) => {
            state.categorisedVulnerabilityLoading = true;
        });
        builder.addCase(getCategorisedVulnerability.fulfilled, (state, action) => {
            state.categorisedVulnerability = action.payload.data;
            state.categorisedVulnerabilityLoading = false;
        });
        builder.addCase(getCategorisedVulnerability.rejected, (state, action) => {
            state.categorisedVulnerabilityLoading = false;
        });
        builder.addCase(getOpenedResolvedIssues.pending, (state, action) => {
            state.openedResolvedIssuesLoading = true;
        });
        builder.addCase(getOpenedResolvedIssues.fulfilled, (state, action) => {
            state.openedResolvedIssues = action.payload.data;
            state.openedResolvedIssuesLoading = false;
        });
        builder.addCase(getOpenedResolvedIssues.rejected, (state, action) => {
            state.openedResolvedIssuesLoading = false;
        });
        builder.addCase(getTopIssues.pending, (state, action) => {
            state.topIssuesLoading = true;
        });
        builder.addCase(getTopIssues.fulfilled, (state, action) => {
            state.topIssues = action.payload.data;
            state.topIssuesLoading = false;
        });
        builder.addCase(getTopIssues.rejected, (state, action) => {
            state.topIssuesLoading = false;
        });
        builder.addCase(getMapDomains.fulfilled, (state, action) => {
            state.mapDomains = action.payload.data;
            state.mapLoading = false;
        });
        builder.addCase(getMapDomains.pending, (state, action) => {
            state.mapDomains = null;
            state.mapLoading = true;
        });
        builder.addCase(getMapDomains.rejected, (state, action) => {
            state.mapLoading = false;
        });
        builder.addCase(getDashboardDomainsFiltered.pending, (state, action) => {
            state.dashboardDomains = null;
            state.getDashboardDomainsFilteredLoading = true;
        });
        builder.addCase(getDashboardDomainsFiltered.fulfilled, (state, action) => {
            state.dashboardDomains = action.payload.data.content;
            state.getDashboardDomainsFilteredLoading = false;
        });
        builder.addCase(getDashboardDomainsFiltered.rejected, (state, action) => {
            state.getDashboardDomainsFilteredLoading = false;
        });
        builder.addCase(getAssetsWithMostIssues.pending, (state, action) => {
            state.assetsWithMostIssuesLoading = false;
        });
        builder.addCase(getAssetsWithMostIssues.fulfilled, (state, action) => {
            state.assetsWithMostIssues = action.payload.data;
            state.assetsWithMostIssuesLoading = false;
        });
        builder.addCase(getAssetsWithMostIssues.rejected, (state, action) => {
            state.assetsWithMostIssuesLoading = false;
        });
        builder.addCase(getTechnologiesWithMostIssues.pending, (state, action) => {
            state.technologiesWithMostIssuesLoading = false;
        });
        builder.addCase(getTechnologiesWithMostIssues.fulfilled, (state, action) => {
            state.technologiesWithMostIssues = action.payload.data;
            state.technologiesWithMostIssuesLoading = false;
        });
        builder.addCase(getTechnologiesWithMostIssues.rejected, (state, action) => {
            state.technologiesWithMostIssuesLoading = false;
        });
        builder.addCase(getPerformanceTestResults.pending, (state, action) => {
            state.performanceTestResultLoading = true;
        });
        builder.addCase(getPerformanceTestResults.fulfilled,(state, action) => {
            state.performanceTestResults = action.payload.data;
            state.performanceTestResultLoading = false;
        });
        builder.addCase(getPerformanceTestResults.rejected, (state, action) => {
            state.performanceTestResultLoading = false;
        });
        builder.addCase(getCountryInfo.pending, (state, action) => {
            state.countryLoading = true;
        });
        builder.addCase(getCountryInfo.fulfilled, (state, action) => {
            state.countryInfo = action.payload.data;
            state.countryLoading = false;
        });
        builder.addCase(getCountryInfo.rejected, (state, action) => {
            state.countryLoading = false;
        });
    }
});

export const {
    
} = dashboardSlice.actions;

export default dashboardSlice.reducer;